import { render, staticRenderFns } from "./Authentication.vue?vue&type=template&id=704df48c&scoped=true"
import script from "./Authentication.vue?vue&type=script&lang=ts"
export * from "./Authentication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704df48c",
  null
  
)

export default component.exports